module.exports = __webpack_public_path__ + "static/media/wishlistIcon.27c69c39.svg";